import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataService, EntityManager, EntityQuery, NamingConvention } from 'breeze-client';
import { AjaxHttpClientAdapter } from 'breeze-client/adapter-ajax-httpclient';
import { DataServiceWebApiAdapter } from 'breeze-client/adapter-data-service-webapi';
import { ModelLibraryBackingStoreAdapter } from 'breeze-client/adapter-model-library-backing-store';
import { UriBuilderJsonAdapter } from 'breeze-client/adapter-uri-builder-json';
import { environment } from '../../../environments/environment';
import { Entities } from './entities';
import { ArkRegistrationHelper } from '../model/registration-helper';

@Injectable()
export class EntityManagerProvider {
    private static _preparePromise: Promise<any> | null;
    private static _masterManager: EntityManager;
    static serviceName: string;

    constructor(http: HttpClient) {
        // the order is important
        ModelLibraryBackingStoreAdapter.register();
        UriBuilderJsonAdapter.register();
        AjaxHttpClientAdapter.register(http);
        DataServiceWebApiAdapter.register();

        NamingConvention.camelCase.setAsDefault();

        EntityManagerProvider.serviceName = environment.serviceName + '/api/breeze';
    }

    async prepare(): Promise<any> {
        if (!EntityManagerProvider._preparePromise) {
            try {
                const dataService = new DataService({
                    serviceName: EntityManagerProvider.serviceName,
                    hasServerMetadata: false,
                });

                const masterManager = (EntityManagerProvider._masterManager = new EntityManager({
                    dataService: dataService,
                }));

                const storageVersion = window.sessionStorage.getItem('breeze.serviceVersion');

                EntityManagerProvider._preparePromise = masterManager
                    .fetchMetadata()
                    .then(() => {
                        ArkRegistrationHelper.register(masterManager.metadataStore);
                        const query = EntityQuery.from('lookups');
                        return masterManager.executeQuery(query).then((data) => {
                            Entities.lookups = data.results[0];
                            return Entities.lookups;
                        });
                    })
                    .catch((e) => {
                        EntityManagerProvider._preparePromise = null;
                        throw e;
                    });
                return EntityManagerProvider._preparePromise;
            } catch (e) {
                EntityManagerProvider._preparePromise = null;
                throw e;
            }
        }

        return EntityManagerProvider._preparePromise;
    }

    reset(manager: EntityManager): void {
        if (manager) {
            manager.clear();
            this.seedManager(manager);
        }
    }

    newManager(): EntityManager {
        const manager = EntityManagerProvider._masterManager.createEmptyCopy();
        this.seedManager(manager);
        return manager;
    }

    private seedManager(manager: EntityManager) {
        manager.importEntities(EntityManagerProvider._masterManager.exportEntities(undefined, { asString: false, includeMetadata: false }));
    }
}
